"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StoredImage = void 0;
var _useStoredImageUrl2 = require("../../hooks/use-stored-image-url");
var _jsxRuntime = require("react/jsx-runtime");
var StoredImage = exports.StoredImage = function StoredImage(_ref) {
  var storedImage = _ref.storedImage,
    className = _ref.className,
    placeholder = _ref.placeholder;
  var _useStoredImageUrl = (0, _useStoredImageUrl2.useStoredImageUrl)(storedImage),
    imageUrl = _useStoredImageUrl.imageUrl,
    isUnavailable = _useStoredImageUrl.isUnavailable;
  if (isUnavailable) return null;
  if (!imageUrl) return placeholder;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("img", {
    src: imageUrl,
    alt: storedImage.fileName,
    className: className,
    "data-sentry-component": "StoredImage",
    "data-sentry-source-file": "StoredImage.tsx"
  });
};